import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isRequesting: false,
    error: null,
    // Danh sách bảng kê tổng hợp thu tiền
    data: [],
    total: 0,
    searchCriteria: {}, // filter lệnh vận chuyển chưa xác nhận

    // find-transport-orders
    dataFindTransportOrders: [],
    searchCriteriaBelow: {}, // filter lệnh vận chuyển đã xác nhận

    // type active
    typeActive: 0,

    // history
    dataHistory: [],

    // list file
    dataListFile: [],
    searchCriteriaFile: {},

    dataPrint: [],
};
const slice = createSlice({
    name: 'shippingOrder',
    initialState: initialState,
    reducers: {
        get_list: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload },
            };
        },
        get_list_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload,
            };
        },
        get_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                // data: [],
                // total: 0,
            };
        },

        create_transport_order: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        create_transport_order_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        //
        get_list_find_transport_orders: (state, action) => {
            const { body } = action.payload;
            return {
                ...state,
                isRequesting: true,
                searchCriteria: body,
            };
        },
        get_list_find_transport_orders_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload?.data,
                total: action.payload?.total,
            };
        },
        //
        get_list_find_transport_orders_below: (state, action) => {
            const { body } = action.payload;
            return {
                ...state,
                isRequesting: true,
                searchCriteriaBelow: body,
            };
        },
        get_list_find_transport_orders_below_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                dataFindTransportOrders: action.payload?.data,
                totalFindTransportOrders: action.payload?.total,
            };
        },

        get_list_find_transport_orders_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                // data: [],
                // total: 0,
            };
        },

        update_transport_order: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        update_transport_order_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        save_active_type: (state, action) => {
            return {
                ...state,
                typeActive: action.payload,
            };
        },

        get_history: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        save_history: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                dataHistory: action.payload,
            };
        },

        confirm_transport_order: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        confirm_transport_order_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },

        get_file_transport_order: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                searchCriteriaFile: action.payload,
            };
        },
        get_file_transport_order_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                dataListFile: action.payload,
            };
        },
        delete_file_transport_order: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        delete_file_transport_order_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
            };
        },

        // dùng để get data in lệnh vận chuyển
        get_transport_orders_print: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        get_transport_orders_print_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                dataPrint: action.payload,
            };
        },

        // upload file
        upload_file_transport_orders: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        upload_file_transport_orders_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
            };
        },

        reset_state: (state) => {
            return {
                ...initialState,
                typeActive: state.typeActive,
            };
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
